import { SignInReducer,SignOutReducer } from './auth.signin.reducer';
import { ResetPasswordReducer, ChangePasswordReducer } from './auth.password.reducer';

export const AuthReducers = {
  signIn: SignInReducer,
  signOut: SignOutReducer,
  resetPassword: ResetPasswordReducer,
  changePassword: ChangePasswordReducer
};

